import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { CampanhaFilter } from '../../filter';
import { CampanhaROIChart } from '../roi';

@Injectable({
    providedIn: 'root'
})
export class CampanhaChartsHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiChart()}/campanha`;
    }

    /** Carrega o chart de ROI das campanhas */
    roi(filter: CampanhaFilter): Observable<CampanhaROIChart> {
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<CampanhaROIChart>(`${this.pathApi}/roi`, {params});
    }

    /** Carrega o chart de ROI dos pacotes das campanhas */
    roiPacotes(filter: CampanhaFilter): Observable<CampanhaROIChart> {
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<CampanhaROIChart>(`${this.pathApi}/roi/pacote`, {params});
    }
}
